import { useState } from "react";
import { NavLink } from "react-router-dom";
import { api, auth } from "../api";
import { ProgressStrip } from "../progress";
import { usePoll } from "./common";

const NAV = [
  { to: "/", end: true, ic: "▣", label: "Tableau de bord" },
  { to: "/paris", ic: "⇄", label: "Paris" },
  { to: "/performance", ic: "◈", label: "Performance" },
  { to: "/systeme", ic: "⚙", label: "Système" },
  { to: "/manager", ic: "✦", label: "Manager" },
  { to: "/reglages", ic: "⚑", label: "Réglages" },
];

export default function Layout({ user, children }) {
  const [menuOpen, setMenuOpen] = useState(false);
  // /settings (léger) plutôt que /dashboard : pollé toutes les 30 s pour la pastille d'état.
  const { data: s } = usePoll(() => api("/settings").then((d) => d?.settings || null), 30000);

  function logout() { auth.clear(); window.dispatchEvent(new Event("predicty-logout")); }

  const live = s?.mode === "live";
  const cls = s?.paused ? "paused" : live ? (s?.live_trading_armed ? "live" : "off") : "sim";
  const text = s?.paused ? "En pause" : live ? (s?.live_trading_armed ? "Réel · ordres automatiques" : "Réel · signaux seulement") : "Simulation";
  const sub = s?.paused ? (s?.pause_reason || "coupe-circuit") : live ? (s?.live_trading_armed ? "argent réel engagé" : "rien n'est placé") : "aucun argent engagé";

  return (
    <div className="admin">
      <div className="topbar">
        <button className="hamburger" onClick={() => setMenuOpen(true)} aria-label="Menu">☰</button>
        <div className="brand">Predict<span className="dot">y</span></div>
        <span style={{ width: 24 }} />
      </div>
      {menuOpen && <div className="drawer-back" onClick={() => setMenuOpen(false)} />}
      <aside className={"sidebar" + (menuOpen ? " open" : "")}>
        <div className="brand">Predict<span className="dot">y</span></div>
        <div className={"status-pill " + cls} title={sub}>
          <span className={"dot " + (cls === "live" ? "dot-up dot-live" : cls === "paused" ? "dot-down" : cls === "off" ? "dot-warn" : "dot-accent")} />
          <span>{s ? text : "…"}<small>{s ? sub : ""}</small></span>
        </div>
        {NAV.map((n) => (
          <NavLink key={n.to} to={n.to} end={n.end} onClick={() => setMenuOpen(false)} className={({ isActive }) => "navitem" + (isActive ? " active" : "")}>
            <span className="ic">{n.ic}</span>{n.label}
          </NavLink>
        ))}
        <div className="spacer" />
        <div className="user">
          <div className="ellipsis" title={user?.email}>{user?.email}</div>
          <button className="btn btn-quiet btn-sm" style={{ marginTop: 6, padding: "4px 0" }} onClick={logout}>Se déconnecter</button>
        </div>
      </aside>
      <main className="main">{children}</main>
      <ProgressStrip />
    </div>
  );
}
